import { AlertTriangle } from "lucide-react";

export default function ShippingDisclaimer({ compact = false }) {
  return (
    <div className="shipping-alert" data-testid="shipping-disclaimer">
      <AlertTriangle size={18} className="shrink-0 mt-0.5" />
      <div>
        <div className="font-medium text-[#FCA5A5] mb-1">
          We do NOT ship Kratom to Indonesia or restricted countries/states.
        </div>
        {!compact && (
          <div className="text-[#FCA5A5]/80 text-xs leading-relaxed">
            <strong>Restricted US states:</strong> Alabama, Arkansas, Indiana, Louisiana,
            Vermont, Wisconsin.
            <br />
            <strong>International:</strong> Australia, Denmark, Finland, Israel, Japan,
            Malaysia, Myanmar, New Zealand, Poland, Romania, Russia, Singapore, South Korea,
            Sweden, Thailand, United Kingdom, Vietnam, Indonesia.
          </div>
        )}
      </div>
    </div>
  );
}
